import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { dashboardUrl } from "../../config/app";
import { FaInstagram, FaFacebookF, FaLinkedinIn, FaEnvelope } from "react-icons/fa6";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column">
          <h4>Product</h4>
          <ul>
            <li><Link to="/features">Features</Link></li>
            <li><Link to="/email-marketing-platform">Email marketing platform</Link></li>
            <li><Link to="/email-marketing-software">Email marketing software</Link></li>
            <li><Link to="/templates">Email templates</Link></li>
            <li><Link to="/automation">Automation</Link></li>
            <li><Link to="/email-automation-software">Email automation software</Link></li>
            <li><Link to="/analytics">Analytics</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Resources</h4>
          <ul>
            <li><Link to="/guide">Email marketing guide</Link></li>
            <li><Link to="/gettingstarted">Getting started guide</Link></li>
            <li><Link to="/GuideSubjectLines">Subject line guide</Link></li>
            <li><Link to="/GuideEffectiveEmail">Effective email guide</Link></li>
            <li><Link to="/GuidePersonalising">Personalization guide</Link></li>
            <li><Link to="/GuideScheduling">Email scheduling guide</Link></li>
            <li><Link to="/GuideMeasureSuccess">Measure email success</Link></li>
            <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/grow-audience">Grow your audience</Link></li>
            <li><Link to="/segmentation">Segmentation</Link></li>
            <li><Link to="/newsletter-software">Newsletter software</Link></li>
            <li><Link to="/email-campaign-software">Email campaign software</Link></li>
            <li><Link to="/email-template-builder">Email template builder</Link></li>
            <li><Link to="/faq">Email marketing FAQ</Link></li>
            <li><a href={dashboardUrl("/sender-authentication")}>Sender authentication</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Company</h4>
          <ul>
            <li><Link to="/about">About us</Link></li>
            <li><Link to="/contact">Contact us</Link></li>
            <li><Link to="/mailchimp-alternative">Mailchimp alternative</Link></li>
            <li><Link to="/alternatives">All alternatives</Link></li>
            <li><Link to="/brevo-alternative">Brevo alternative</Link></li>
            <li><Link to="/constant-contact-alternative">Constant Contact alternative</Link></li>
            <li><Link to="/mailerlite-alternative">MailerLite alternative</Link></li>
            <li><Link to="/klaviyo-alternative">Klaviyo alternative</Link></li>
            <li><a href={dashboardUrl("/login")}>Login</a></li>
            <li><a href={dashboardUrl("/")}>Open dashboard</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Legal</h4>
          <ul>
            <li><Link to="/terms">Terms of use</Link></li>
            <li><Link to="/acceptable">Acceptable use policy</Link></li>
            <li><Link to="/privacy">Privacy policy</Link></li>
            <li><Link to="/cookie">Cookie policy</Link></li>
            <li><Link to="/gdpr">GDPR</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-social">
        <a href="https://instagram.com/mailsnappy/" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
  <FaInstagram />
</a>
<a href="https://www.facebook.com/profile.php?id=61593541164086" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
  <FaFacebookF />
</a>
<a href="https://www.linkedin.com/company/mailsnappy/" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
  <FaLinkedinIn />
</a>
      </div>

      <div className="footer-support">
        <FaEnvelope aria-hidden="true" />
        <p>
          Facing a technical issue or need more information? Write to us at{" "}
          <a href="mailto:support@mailsnappy.com">support@mailsnappy.com</a> and
          our team will get back to you.
        </p>
      </div>

  
    </footer>
  );
};

export default Footer;
